<section class="auto-ship-products">
  <nav class="auto-ship-navigation" [attr.aria-label]="'autoShip.schedule.navigationLabel' | cxTranslate">
    <span class="auto-ship-navigation__item" aria-current="page">
      {{ 'autoShip.products.partsSelectionTab' | cxTranslate }}
    </span>

    <span class="auto-ship-navigation__item auto-ship-navigation__item--active">
      {{ 'autoShip.schedule.shipmentScheduleTab' | cxTranslate }}
    </span>
  </nav>

  <h1 class="title">{{ 'autoShip.schedule.title' | cxTranslate }}</h1>

  <div class="auto-ship-layout">
    <div class="results">
      
    <gen-auto-ship-shipment-frequency
      (numberOfShipmentsChange)="onNumberOfShipmentsChange($event)"
    ></gen-auto-ship-shipment-frequency>

    <gen-auto-ship-shipment-date
      [numberOfShipments]="numberOfShipments"
    ></gen-auto-ship-shipment-date>
      
    </div>
  </div>
</section>
